declare global {
  interface Window {
    Razorpay?: any;
  }
}
export {};

import React, { useEffect } from 'react';


// Hook version for easier usage
export const useRazorpay = () => {
  const [isScriptLoaded, setIsScriptLoaded] = React.useState(false);

  useEffect(() => {
    if (window.Razorpay) {
      setIsScriptLoaded(true);
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    script.onload = () => setIsScriptLoaded(true);
    document.body.appendChild(script);

    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  interface PaymentOptions {
    amount: number;
    currency?: string;
    orderId: string;
    keyId: string;
    name?: string;
    description?: string;
    image?: string;
    prefill?: {
      name?: string;
      email?: string;
      contact?: string;
    };
    theme?: {
      color?: string;
    };
    onSuccess?: (response: { razorpay_payment_id: string; razorpay_order_id: string; razorpay_signature: string }) => void;
    onFailure?: (error: { code: string; description: string; source: string; step: string; reason: string; metadata: any }) => void;
    onDismiss?: (response: {orderId: string}) => void;
    notes?: Record<string, any>;
    readonly?: Record<string, any>;
  }

  const initiatePayment = (options: PaymentOptions) => {
    if (!window.Razorpay) {
      console.error('Razorpay SDK not loaded');
      return;
    }

    const {
      amount,
      currency = 'INR',
      orderId,
      keyId,
      name = 'Your Company',
      description = 'Payment for services',
      image = '',
      prefill = {},
      theme = { color: '#3399cc' },
      onSuccess,
      onFailure,
      onDismiss,
      notes = {},
      readonly = {}
    } = options;

    const razorpayOptions = {
      key: keyId,
      // amount: amount * 100,
      currency,
      name,
      description,
      image,
      order_id: orderId,
      handler: function (response: { razorpay_payment_id: string; razorpay_order_id: string; razorpay_signature: string }) {
        if (onSuccess) {
          onSuccess({
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_order_id: response.razorpay_order_id,
            razorpay_signature: response.razorpay_signature
          });
        }
      },
      prefill: {
        name: prefill.name || '',
        email: prefill.email || '',
        contact: prefill.contact || ''
      },
      notes,
      theme,
      readonly,
      modal: {
        ondismiss: function() {
          if (onDismiss) {
            onDismiss({orderId: orderId});
          }
        }
      },
      timeOut: 420 // 7 minutes
    };

    const rzp = new window.Razorpay(razorpayOptions);
    
    rzp.on('payment.failed', function (response: { error: { code: string; description: string; source: string; step: string; reason: string; metadata: any } }) {
      if (onFailure) {
        onFailure({
          code: response.error.code,
          description: response.error.description,
          source: response.error.source,
          step: response.error.step,
          reason: response.error.reason,
          metadata: response.error.metadata
        });
      }
    });

    rzp.open();
  };

  return { initiatePayment, isScriptLoaded };
};

export default useRazorpay;
